import React from "react";
import CommonImageSlider from "./comandata";
import CallandRegisterComponent from "./Callbutton";
import { acadmicImages, homeImages, jeeRanks, mpcwithiit } from "./data";
import SeoMeta from "./seometa/seometa";
import CommonImageSliderRanks from "./CommonsliderRanks";
import { CommonAboutHeader } from "./CommonAboutHeader";
import WhyRankridgeMPC from "./WhyRankridgeMPC";
import { AboutSection, HeroSection } from "./courses/commoncomponents";
import mpc from '../assets/iitjee/mpc.png'
const seoMPC = {
  title: "MPC with IITJEE Coaching – Best Junior Colleges in Hyderabad",
  description: "Excel in IIT JEE & board exams with Rankridge’s MPC Intermediate integrated coaching. Expert mentors & proven results in competitive exams.",
  keywords: "MPC Junior College Hyderabad, MPC with IIT JEE Foundation Hyderabad, Best MPC Junior College in Hyderabad, MPC Intermediate Colleges Hyderabad, IIT JEE Foundation Junior College Hyderabad, Junior Colleges with IIT JEE Coaching, Best IIT JEE Junior Colleges in Hyderabad, MPC Residential Junior Colleges Hyderabad, MPC Colleges with Hostel Facility Hyderabad, Best Residential MPC Colleges Hyderabad, MPC with IIT Coaching Hyderabad, IIT JEE Coaching with MPC Junior College, MPC Junior College KPHB, Best MPC Colleges Near Kukatpally, Top MPC Junior Colleges Near Hitech City, Rankridge MPC Junior College, Rankridge IIT JEE Foundation, Best IIT JEE Preparation Junior College Hyderabad, IIT Coaching Junior College Hyderabad, Junior College for IIT Coaching Hyderabad, MPC with Engineering Foundation Hyderabad, MPC Intermediate Course Hyderabad, MPC Junior College Admissions Hyderabad, Best Junior Colleges for IIT JEE Coaching, Best MPC Colleges for IIT Aspirants, Top MPC Residential Colleges Hyderabad",
  canonical_path: "https://www.rankridge.com/mpc-with-iit-jee/",
  og_description: "",
  og_image: "",
};


const title=` Best junior Colleges For`
const courseName1='MPC' 
const courseName2="IIT-JEE"
const titleend='Coaching'
const symbol="With"
const description="At Rankridge Junior College, our Best MPC with IIT-JEE program blends Intermediate curriculum with focused coaching for IIT-JEE Mains & Advanced. With IITian faculty, concept clarity sessions, and regular practice tests, we prepare students for top engineering colleges across India."

const aboutTitle='About Rankridge College'
const aboutDescription=`Rankridge College is one of Hyderabad’s leading MPC junior colleges with IIT-JEE coaching, trusted by parents and students for more than two decades. With faculty from IITs and NITs, we integrate the MPC syllabus with advanced JEE preparation to ensure complete exam readiness.
Our success is reflected in students consistently achieving Top 100 All India Ranks and securing seats at IITs, NITs, and IIITs. Small batch sizes, daily doubt-clearing, and exclusive study material help every student learn with focus.` 
const description2='Beyond academics, Rankridge emphasizes stress-free education through balanced timetables, yoga, and mentoring, while parents stay updated via digital progress monitoring. With residential, semi-residential, and day scholar options, we provide a supportive environment where students can truly excel.' 
 


const MpcWithIIT = () => {
  return (
    <div>
<HeroSection sparktext="Hyderabad’s Best  MPC with IIT-JEE" description={description}  title={title}  courseName1={courseName1} courseName2={courseName2} titleend={titleend} symbol={symbol} imagePath={mpc}  />

<section className="p-2">


<AboutSection title={aboutTitle} description={aboutDescription} description2={description2} imagePath={acadmicImages[0]}   />

<WhyRankridgeMPC />

</section>


    <SeoMeta seopages={seoMPC} />
    </div>
  );
};
export default MpcWithIIT;